function isEventProp(name: string) {
  return /^on/.test(name);
}

function extractEventName(name: string) {
  return name.slice(2).toLowerCase();
}

function setBooleanProp(target: any, name: string, value: boolean) {
  if (value) {
    target.setAttribute(name, value);
    target[name] = true;
  } else {
    target[name] = false;
  }
}

function setProp(target: Element, name: string, value: any) {
  if (isEventProp(name)) {
    target.addEventListener(extractEventName(name), value);
  } else if (typeof value === 'boolean') {
    setBooleanProp(target, name, value);
  } else {
    target.setAttribute(name, value);
  }
}

function setProps(target: Element, props: {[name: string]: any}) {
  Object.entries(props).forEach(([name, value]) => setProp(target, name, value));
}

export function insertScript(props: {[name: string]: any}) {
  const script = document.createElement('script');
  setProps(script, props);
  const sibling = document.getElementsByTagName('script')[0];
  sibling.parentNode!.insertBefore(script, sibling);
  return script;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/shared/script.ts